import { SimCard } from '../types';

export const simCards: SimCard[] = [
  {
    id: '1',
    name: 'Europe Travel SIM',
    country: 'Europe',
    region: 'Europe',
    price: 29.99,
    dataAllowance: '10GB',
    validity: '30 days',
    coverage: ['Germany', 'France', 'Italy', 'Spain', 'Netherlands', 'Belgium', 'Austria'],
    features: ['4G/5G Speed', 'Hotspot Enabled', 'No Roaming Charges'],
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop',
    inStock: true
  },
  {
    id: '2',
    name: 'Asia Pacific SIM',
    country: 'Asia',
    region: 'Asia Pacific',
    price: 34.99,
    dataAllowance: '15GB',
    validity: '30 days',
    coverage: ['Japan', 'South Korea', 'Singapore', 'Thailand', 'Malaysia', 'Hong Kong'],
    features: ['5G Ready', 'Unlimited Social Media', 'Voice Calls Included'],
    image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?w=300&h=200&fit=crop',
    inStock: true
  },
  {
    id: '3',
    name: 'USA & Canada SIM',
    country: 'North America',
    region: 'North America',
    price: 39.99,
    dataAllowance: '20GB',
    validity: '30 days',
    coverage: ['United States', 'Canada'],
    features: ['Unlimited Calls & SMS', '5G Network', 'Hotspot 10GB'],
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop',
    inStock: true
  },
  {
    id: '4',
    name: 'Global Roaming SIM',
    country: 'Worldwide',
    region: 'Global',
    price: 59.99,
    dataAllowance: '25GB',
    validity: '60 days',
    coverage: ['150+ Countries', 'All Major Networks'],
    features: ['Global Coverage', 'Premium Support', 'Multi-Network'],
    image: 'https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?w=300&h=200&fit=crop',
    inStock: true
  },
  {
    id: '5',
    name: 'UK & Ireland SIM',
    country: 'United Kingdom',
    region: 'Europe',
    price: 24.99,
    dataAllowance: '8GB',
    validity: '30 days',
    coverage: ['United Kingdom', 'Ireland'],
    features: ['4G Speed', 'Local Numbers', 'EU Roaming'],
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=300&h=200&fit=crop',
    inStock: true
  },
  {
    id: '6',
    name: 'Australia & New Zealand SIM',
    country: 'Australia',
    region: 'Oceania',
    price: 32.99,
    dataAllowance: '12GB',
    validity: '30 days',
    coverage: ['Australia', 'New Zealand'],
    features: ['5G Network', 'Unlimited SMS', 'Voice Calls'],
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=200&fit=crop',
    inStock: false
  }
];
